'use client';

import Icon from '@/components/ui/AppIcon';

export type ViewMode = 'list' | 'calendar' | 'timeline';

interface ViewModeToggleProps {
  currentMode: ViewMode;
  onModeChange: (mode: ViewMode) => void;
}

const ViewModeToggle = ({ currentMode, onModeChange }: ViewModeToggleProps) => {
  const modes: { value: ViewMode; label: string; icon: string }[] = [
    { value: 'list', label: 'List View', icon: 'ListBulletIcon' },
    { value: 'calendar', label: 'Calendar View', icon: 'CalendarIcon' },
    { value: 'timeline', label: 'Timeline View', icon: 'ClockIcon' },
  ];

  return (
    <div data-component-id="src/app/all-bookings-view/components/ViewModeToggle.tsx:20:4" data-component-path="src/app/all-bookings-view/components/ViewModeToggle.tsx" data-component-line="20" data-component-end-line="40" data-component-file="ViewModeToggle.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22inline-flex%20bg-muted%20rounded-lg%20p-1%22%7D" className="inline-flex bg-muted rounded-lg p-1">
      {modes.map((mode) => (
        <button data-component-id="src/app/all-bookings-view/components/ViewModeToggle.tsx:22:8" data-component-path="src/app/all-bookings-view/components/ViewModeToggle.tsx" data-component-line="22" data-component-end-line="38" data-component-file="ViewModeToggle.tsx" data-component-name="button" data-component-content="%7B%22elementName%22%3A%22button%22%7D"
          key={mode.value}
          onClick={() => onModeChange(mode.value)}
          className={`
            px-4 py-2 rounded-md font-caption font-medium text-sm
            transition-smooth focus-ring flex items-center gap-2
            ${
              currentMode === mode.value
                ? 'bg-card text-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground'
            }
          `}
          aria-label={mode.label}
        >
          <Icon data-component-id="src/app/all-bookings-view/components/ViewModeToggle.tsx:36:10" data-component-path="src/app/all-bookings-view/components/ViewModeToggle.tsx" data-component-line="36" data-component-end-line="36" data-component-file="ViewModeToggle.tsx" data-component-name="Icon" data-component-content="%7B%22elementName%22%3A%22Icon%22%7D" name={mode.icon as any} size={18} />
          <span data-component-id="src/app/all-bookings-view/components/ViewModeToggle.tsx:37:10" data-component-path="src/app/all-bookings-view/components/ViewModeToggle.tsx" data-component-line="37" data-component-end-line="37" data-component-file="ViewModeToggle.tsx" data-component-name="span" data-component-content="%7B%22elementName%22%3A%22span%22%2C%22className%22%3A%22hidden%20md%3Ainline%22%7D" className="hidden md:inline">{mode.label}</span>
        </button>
      ))}
    </div>
  );
};

export default ViewModeToggle;
